var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9.99992 3.00012C11.6599 3.00012 12.9999 4.34012 12.9999 6.00012C12.9999 7.66012 11.6599 9.00012 9.99992 9.00012C8.33992 9.00012 6.99992 7.66012 6.99992 6.00012C6.99992 4.34012 8.33992 3.00012 9.99992 3.00012ZM3.99998 13.9794C5.28998 15.9194 7.49998 17.1994 9.99998 17.1994C12.5 17.1994 14.71 15.9194 16 13.9794C15.97 11.9894 11.99 10.8994 9.99998 10.8994C7.99998 10.8994 4.02998 11.9894 3.99998 13.9794Z",
    fill: "#292E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.02d269cc.svg";
export { ForwardRef as ReactComponent };